module.exports = __webpack_public_path__ + "static/media/discount.78726137.png";